import { message } from "antd";

export const notify = (reply, success) => {
  if (reply && reply.Status === true) {
    if (success) message.success(success);
    return true;
  }
  message.error((reply && (reply.Error || reply.Message)) || "Could not save");
  return false;
};
